var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220mm",
    height: "220mm",
    viewBox: "0 0 220 220",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.687 -33.455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.32 72.72a18 18 0 0 0-18 18 18 18 0 0 0 2.696 9.4759l-16.707 16.707a43.58 43.58 0 0 0-29.144-11.188 43.58 43.58 0 0 0-21.005 5.41 64.605 65.265 45.142 0 0-52.262-26.804 64.605 65.265 45.142 0 0-65.59 64.939 64.605 65.265 45.142 0 0 64.278 64.93 64.605 65.265 45.142 0 0 53.01-27.061 43.58 43.58 0 0 0 21.569 5.7459 43.58 43.58 0 0 0 43.58-43.58 43.58 43.58 0 0 0-9.9916-27.76l16.573-16.573a18 18 0 0 0 10.995 3.7579 18 18 0 0 0 18-18 18 18 0 0 0-18-18zm-135.73 40.191a36.642 36.642 0 0 1 35.809 28.901h17.186a23.223 23.223 0 0 1 21.836-15.483 23.223 23.223 0 0 1 23.224 23.223 23.223 23.223 0 0 1-23.224 23.224 23.223 23.223 0 0 1-21.835-15.482h-17.203a36.642 36.642 0 0 1-35.793 28.9 36.642 36.642 0 0 1-36.641-36.642 36.642 36.642 0 0 1 36.641-36.641z",
    fill: "#68b9b6",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbueLogo);
export default __webpack_public_path__ + "static/media/embue_logo.fbc43066d0a8237ffedf2c49b47a92c1.svg";
export { ForwardRef as ReactComponent };